import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetWithDatabaseAdapts } from './tabular-type.dataset.adapter';
import { AzureSqlMITableDataset } from 'app/model/dataset/azure-sql-mi-table.dataset';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlMITableDataset),
    asynchronous: true,
    adapts: {
        ...tabularTypeDatasetWithDatabaseAdapts,
        properties: {
            ...tabularTypeDatasetWithDatabaseAdapts.properties,
            connectionProperties: GlobalVariables.connectionPropertiesForSql ? '*' : undefined
        }
    }
})
export class AzureSqlMITableDatasetAdapter extends TabularTypeDatasetAdapter<AzureSqlMITableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureSqlMITableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureSqlMITableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlMITableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureSqlMITableDataset): Promise<AzureSqlMITableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            AzureSqlMITableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureSqlMITableDataset.DATABASE : undefined);
    }
}
